const PageNotFound=()=>{
    return(
        <div style={{height:"100vh",backgroundColor:"black",color:"white",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
           <div >
             <h3>404| Page Not Found</h3>
          </div> 
        </div>
    )
}

export default PageNotFound
